import {placeEquityWizard, PlaceEquityWizard} from "./PlaceEquityOrderWizard";
import {equityOrderStep, EquityOrderStep} from "./steps/order-step/EquityOrderStep";
import {equityOrderConfirm, EquityOrderConfirm} from "./steps/confirm-step/EquityOrderConfirmStep";
import {
    equityPortfolioImpact,
    EquityPortfolioImpact
} from "./steps/equity-portfolio-impact/EquityPortfolioImpactComponent";

export default angular.module("tfApp.portfolio.equity-order-wizard", [])
                      .component(PlaceEquityWizard, placeEquityWizard())
                      .component(EquityOrderStep, equityOrderStep())
                      .component(EquityOrderConfirm, equityOrderConfirm())
                      .component(EquityPortfolioImpact, equityPortfolioImpact())
                      .name;
